// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"

// Make bootstrap available globally for modals etc.
window.bootstrap = bootstrap
